<template>
  <div :class="['author-meta', { 'author-meta--compact': compact }]">
    <img
      src="/assets/images/blog/autor_icon.svg"
      alt=""
      class="author-meta__icon"
      width="12"
      height="15"
      loading="lazy"
      decoding="async"
    >
    <span class="author-meta__label">{{ label }}: {{ name }}</span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string
  name: string
  compact?: boolean
}

withDefaults(defineProps<Props>(), {
  compact: false,
})
</script>

<style scoped>
.author-meta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.author-meta__icon {
  flex-shrink: 0;
  width: 12px;
  height: 15px;
}

.author-meta__label {
  font-family: var(--font-inter);
  font-weight: var(--font-weight-regular);
  font-size: 19px;
  line-height: 30px;
  color: #868D98;
}

.author-meta--compact .author-meta__label {
  font-size: 14px;
  line-height: var(--line-height-tight);
  color: var(--color-grey);
}

@media (max-width: 991px) {
  .author-meta__label {
    font-size: 17px;
  }
}

@media (max-width: 767px) {
  .author-meta__label {
    font-size: 17px;
  }
}
</style>
